import dashboardApi from 'services/api/dashboard'

import { pushElectronDashboardAuthSnapshot } from './electronDashboardAuthSync'
import { tryRenewStoredSession } from './tryRenewStoredSession'

/**
 * Resolves dashboard login status for Electron IPC handlers.
 * Attempts silent session renewal before reporting dead when local credentials exist.
 *
 * @returns {Promise<'alive'|'dead'>}
 */
export async function resolveDashboardLoginStatus() {
  let loginStatus = await dashboardApi.checkLogin()
  if (loginStatus !== 'alive') {
    const renewed = await tryRenewStoredSession({ requireUser: false })
    if (renewed) {
      pushElectronDashboardAuthSnapshot({
        sessionId: renewed.sessionId,
        userToken: renewed.userToken,
        userId: renewed.userId,
        currentUser: renewed.user
      })
      loginStatus = await dashboardApi.checkLogin()
    }
  }
  return loginStatus === 'alive' ? 'alive' : 'dead'
}
